import useSWR from "swr"
import { isAValue } from "web/services/helpers"
import API from "./api"

export default function useGlobalSearch(query) {
  const hasQuery = isAValue(query)
  const key = hasQuery ? ["global_search", query] : null

  function fetchResults() {
    return hasQuery ? API.get("/global_search", { query }) : []
  }

  const { data: results } = useSWR(key, fetchResults, { suspense: true })

  return results
}
